import { Logger } from '../../utils';
import { HREventListener, INotOnboardable, IOnboardable, UnRegisterEventListener } from '../connected-workout-app';
import LoggingConnectedApp from './logging-only-app';

/*
 * connected apps gets build on startup, so (probably) cannot toggle with dev tools
 * importing config has a require cycle
 * setting via env requires a --reset-cache
 * change here (uncommited) for testing
 */
const addMockApp = false;

class MockConnectedApp extends LoggingConnectedApp {
  public async isAvailable(): Promise<boolean> {
    return addMockApp && __DEV__;
  }

  public async isAppInstalledOnConnectedDevice(): Promise<boolean> {
    return true;
  }

  public async isConnectedDeviceAvailable(): Promise<boolean> {
    return true;
  }

  public async isOnboardable(): Promise<IOnboardable | INotOnboardable> {
    return {
      isOnboardable: false,
    };
  }

  public async canUseAsRealtimeHeartRateMonitor(): Promise<boolean> {
    return true;
  }

  public registerHREventHandler(listener: HREventListener): UnRegisterEventListener {
    const timer = setInterval(() => {
      listener(60 + Math.floor(Math.random() * 60));
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }
}

export default new MockConnectedApp('Mock');
